import { render } from "./SwitchInput.vue?vue&type=template&id=27c2f88c"
import script from "./SwitchInput.vue?vue&type=script&lang=js"
export * from "./SwitchInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__